import axios from "axios";
import { MODULE_API } from "../../../../apis";

export default function useUploadDocument(setLoading, setFormData) {
  const handleImageUpload = async (event) => {
    console.log("e.target", event.target);
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      setFormData((prev) => ({
        ...prev,
        ["Document Upload"]: res,
        ["Uploaded File Name"]: fileName,
      }));
    }
  };
  return { handleImageUpload };
}
